// @flow
import type {Element} from 'react'
import React from 'react'
import ReactSelect from 'react-select'
import useSelectEvents from '../useSelectEvents'
import useOptionFormatting from '../useOptionFormatting'
import type {Option, PlaceholderData} from '../types'

export type Props = $ReadOnly<{
  defaultValue?: Object,
  id: string,
  isMulti?: boolean,
  isSearchable?: boolean,
  isClearable?: boolean,
  name: string,
  onChange?: (newValue: Option | Array<Option>, Object) => void,
  onInit?: (selectWrapper: Object) => void,
  options: Array<Option>,
  showSubtitle?: boolean,
  placeholderData?: PlaceholderData,
  wrapperClass?: string,
  iconOnlySelection?: boolean,
}>;

function StaticRailsSelect({defaultValue, id, isMulti,
  isSearchable, isClearable, name, options, showSubtitle, placeholderData,
  wrapperClass, iconOnlySelection, onInit, onChange}: Props): Element<'div'> {
  const {
    handleChange,
    wrapperRef,
    filterOption,
    selectRef,
    menuIsOpen,
    setMenuIsOpen,
    changeInProgress,
  } = useSelectEvents({onInit, onChange})

  const {formatOptionLabel, components}
    = useOptionFormatting(
      options,
      {
        iconOnlySelection,
        showSubtitle,
        placeholderData,
        wrapperRef,
        menuIsOpen,
        changeInProgress,
      },
    )

  return (
    <div ref={wrapperRef} className={wrapperClass} test-id={`RailsSelect-${name}`}>
      <ReactSelect
        defaultValue={defaultValue}
        id={id}
        isMulti={isMulti}
        isSearchable={isSearchable}
        isClearable={isClearable}
        name={name}
        onChange={handleChange}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        options={options}
        placeholder={placeholderData}
        classNamePrefix="rails_select"
        formatOptionLabel={formatOptionLabel}
        filterOption={filterOption}
        components={components}
        ref={selectRef}
        // defaultMenuIsOpen // Uncomment to open the dropdown by default to inspect things in console more easily
      />
    </div>
  )
}

export default StaticRailsSelect
